// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3HG36","empty":"ModalGraph_empty__27t_a"};